import React from 'react';
import { FileManagerRow } from '../../model';

export const CreativeNameCell: React.FC<{ rowData: FileManagerRow }> = ({ rowData }) => {
  if (!rowData.creative_name) {
    return null;
  }

  return (
    <span className="ch-file-manager__cell-content_creative_name" title={rowData.creative_name}>
      {rowData.creative_name}
    </span>
  );
};
